import { Announcement } from '../server/announcements/list/get'
import React from 'react'
import Card from './Card'
import classNames from 'classnames'
import Btn from './Btn'
import { ReactSVG } from 'react-svg'

type AnnouncementOptionalId = Omit<Announcement, 'id'> &
  Partial<Pick<Announcement, 'id'>>

type AnnouncementOptionalTitle = Omit<AnnouncementOptionalId, 'title'> &
  Partial<Pick<AnnouncementOptionalId, 'title'>>

interface Props extends AnnouncementOptionalTitle {
  className?: string
  render?: () => React.ReactElement | string
  headLink?: string
  headLinkText?: string
  id?: string
  title?: string
}

const AnnouncementCard: React.FC<Props> = ({
  pretitle,
  title,
  pictureUrl,
  contrast,
  className,
  description,
  link,
  linkText,
  linkIcon,
  headLink,
  headLinkText,
  render
}) => {
  return (
    <Card
      className={classNames('announcement-card', className, {
        _contrast: contrast
      })}
      style={{
        backgroundImage: !render
          ? `url(${pictureUrl || '/i/ads1.jpg'})`
          : pictureUrl
            ? `url(${pictureUrl})`
            : undefined
      }}
    >
      {render ? (
        <div className="announcement-card__content">
          {pretitle || headLink ? (
            <header className={'announcement-card__head mb-md-5 mb-sm-4'}>
              {pretitle && (
                <p className={'text-h4 announcement-card__subtitle'}>
                  {pretitle}
                </p>
              )}
              {headLink && (
                <Btn to={headLink} text small>
                  <span>{headLinkText}</span>
                  <ReactSVG src={'/i/svg/arrow-right.svg'} />
                </Btn>
              )}
            </header>
          ) : null}
          {render()}
        </div>
      ) : (
        <>
          <div className="announcement-card__content">
            {pretitle || headLink ? (
              <header className={'announcement-card__head mb-md-5 mb-sm-4'}>
                {pretitle && (
                  <p className={'text-h4 announcement-card__subtitle'}>
                    {pretitle}
                  </p>
                )}
                {headLink && (
                  <Btn to={headLink} text small>
                    <span>{headLinkText}</span>
                    <ReactSVG src={'/i/svg/arrow-right.svg'} />
                  </Btn>
                )}
              </header>
            ) : null}

            <div className="announcement-card__text">
              <h2 className="text-h3">{title}</h2>
              {description && (
                <p className={'mt-md-3 mt-sm-2'}>{description}</p>
              )}
            </div>
          </div>

          {link && (
            <footer className="announcement-card__foot">
              <Btn to={link} contrast={contrast}>
                <span>{linkText}</span>
                {linkIcon && <ReactSVG src={linkIcon} wrapper={'span'} />}
              </Btn>
            </footer>
          )}
        </>
      )}
    </Card>
  )
}

export default AnnouncementCard
